import styled from '@emotion/styled'

export const Row = styled.div`
  display: flex;
`
